export const REGISTER_BUDGET_MOVEMENT = `
  mutation RegisterBudgetMovement($meetingId: Int!, $groupIds: [Int!]!, $tenant_id: Int!) {
    registerBudgetMovement(meetingId: $meetingId, groupIds: $groupIds, tenant_id: $tenant_id) {
      __typename
      ... on GroupBudgetMovement {
        id
        group_id
        meeting_id
        amount
        shared_with
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
